import {apiV2} from './api';
import ArchivingProfile from 'records/ArchivingProfile';
import {List} from 'immutable';

function getProfiles() {
  return apiV2
    .getJson('/admin/archiving/profiles')
    .then(({profiles}) => List(profiles.map(profile => new ArchivingProfile(profile))));
}

export default {
  fetchArchivingProfiles() {
    return getProfiles();
  },
  create(profile, shouldOverwrite) {
    return apiV2
      .postJson(`/admin/archiving/profile`, profile.toJS(), {
        params: {overwrite: shouldOverwrite},
      })
      .then(getProfiles);
  },
  update(profile, shouldOverwrite) {
    return apiV2
      .putJson(`/admin/archiving/profile/${profile.id}`, profile.toJS(), {
        params: {overwrite: shouldOverwrite},
      })
      .then(getProfiles);
  },
};
